import {
  Box,
  Feedback,
  Flex,
  FormErrorTypes,
  LocalTimeHoursInput,
} from "dash-ui";
import { WeekDays } from "dash-common";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { SalesGalleryLocalHoursProps } from "./SalesGalleryLocalHours.interfaces";

const StyledWrapper = styled(Flex)`
  max-width: 966px;
`;

const SalesGalleryLocalHours = ({
  setSalesGalleryHours,
  setSalesGalleryHoursError,
  formErrors,
  formState,
}: SalesGalleryLocalHoursProps) => {
  const { t } = useTranslation(["forms", "common"]);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [fieldToReset, setFieldToReset] = useState<{
    field: string;
    isReset: boolean;
  }>({
    field: "",
    isReset: false,
  });

  useEffect(() => {
    if (fieldToReset.isReset) {
      setSalesGalleryHours({
        ...formState.salesGalleryHours,
        [fieldToReset.field]: undefined,
      });
    } else if (fieldToReset.field) {
      // set default hours range
      setSalesGalleryHours({
        ...formState.salesGalleryHours,
        [fieldToReset.field]: {
          from: "10:00",
          to: "18:00",
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldToReset]);

  const onChange = (key: string) => (value: { from?: string; to?: string }) => {
    // Simple time comparison for 24-hour format
    if (value.from && value.to && value.from > value.to) {
      setErrorFields((prev) => [...prev, key]);

      return setSalesGalleryHoursError({
        type: FormErrorTypes.Invalid,
        message: t("forms:messages.workingHoursValidateMessage") as string,
      });
    }
    setSalesGalleryHoursError(null);
    setErrorFields(errorFields.filter((item) => item !== key));
    setSalesGalleryHours({ ...formState.salesGalleryHours, [key]: value });
  };

  return (
    <StyledWrapper flexWrap="wrap" justifyContent="space-between" px={6} mt={8}>
      {Object.values(WeekDays).map((day) => {
        const hours =
          formState.salesGalleryHours && formState.salesGalleryHours[day];

        return (
          <Box key={day} mb={9}>
            <LocalTimeHoursInput
              key={day}
              label={t(`common:labels.weekDays.${day}`)
                .slice(0, day === WeekDays.Tuesday ? 4 : 3)
                .toUpperCase()}
              onSwitch={(checked: boolean) =>
                setFieldToReset({ field: day, isReset: !checked })
              }
              onChange={onChange(day)}
              defaultValue={hours}
            />

            {errorFields.includes(day) && formErrors.salesGalleryHours && (
              <Feedback $errorType={formErrors.salesGalleryHours.type}>
                {formErrors.salesGalleryHours.message}
              </Feedback>
            )}
          </Box>
        );
      })}
    </StyledWrapper>
  );
};

export default SalesGalleryLocalHours;
